import { Notify } from 'quasar';
export class NotificationService {
    static async info(title, description) {
        const notificationId = `notify-${Date.now()}`;
        Notify.create({
            message: `
 
        <div id="${notificationId}" 
        class="notification-container"
        style="
            display: flex;
            justify-content: space-between;
            padding: 12px;
            max-width: 360px;
            background-color: #ffffff;
            border: 1px solid #e0e0e0;
            margin-top: 32px;
            margin-right: 32px;
            border-radius: 4px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            box-sizing: border-box;
            transition: opacity 1s ease, max-height 1s ease, padding 1s ease, margin 1s ease;
            border-left: 4px solid #084CBD;
          ">
            
          <span style="align-items:start; justify-content:start;">
          
          <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="width: 20px; height: 20px; fill:#084CBD; margin-right: 8px;"
        >
          <mask
            id="mask0_2699_58047"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="16"
            height="17"
          >
            <rect y="0.332031" width="16" height="16" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_2699_58047)">
            <path
              d="M8.00016 11.6641C8.18905 11.6641 8.34738 11.6002 8.47516 11.4724C8.60294 11.3446 8.66683 11.1863 8.66683 10.9974V8.33073C8.66683 8.14184 8.60294 7.98351 8.47516 7.85573C8.34738 7.72795 8.18905 7.66406 8.00016 7.66406C7.81127 7.66406 7.65294 7.72795 7.52516 7.85573C7.39738 7.98351 7.3335 8.14184 7.3335 8.33073V10.9974C7.3335 11.1863 7.39738 11.3446 7.52516 11.4724C7.65294 11.6002 7.81127 11.6641 8.00016 11.6641ZM8.00016 6.33073C8.18905 6.33073 8.34738 6.26684 8.47516 6.13906C8.60294 6.01128 8.66683 5.85295 8.66683 5.66406C8.66683 5.47517 8.60294 5.31684 8.47516 5.18906C8.34738 5.06128 8.18905 4.9974 8.00016 4.9974C7.81127 4.9974 7.65294 5.06128 7.52516 5.18906C7.39738 5.31684 7.3335 5.47517 7.3335 5.66406C7.3335 5.85295 7.39738 6.01128 7.52516 6.13906C7.65294 6.26684 7.81127 6.33073 8.00016 6.33073ZM8.00016 14.9974C7.07794 14.9974 6.21127 14.8224 5.40016 14.4724C4.58905 14.1224 3.8835 13.6474 3.2835 13.0474C2.6835 12.4474 2.2085 11.7418 1.8585 10.9307C1.5085 10.1196 1.3335 9.25295 1.3335 8.33073C1.3335 7.40851 1.5085 6.54184 1.8585 5.73073C2.2085 4.91962 2.6835 4.21406 3.2835 3.61406C3.8835 3.01406 4.58905 2.53906 5.40016 2.18906C6.21127 1.83906 7.07794 1.66406 8.00016 1.66406C8.92238 1.66406 9.78905 1.83906 10.6002 2.18906C11.4113 2.53906 12.1168 3.01406 12.7168 3.61406C13.3168 4.21406 13.7918 4.91962 14.1418 5.73073C14.4918 6.54184 14.6668 7.40851 14.6668 8.33073C14.6668 9.25295 14.4918 10.1196 14.1418 10.9307C13.7918 11.7418 13.3168 12.4474 12.7168 13.0474C12.1168 13.6474 11.4113 14.1224 10.6002 14.4724C9.78905 14.8224 8.92238 14.9974 8.00016 14.9974ZM8.00016 13.6641C9.48905 13.6641 10.7502 13.1474 11.7835 12.1141C12.8168 11.0807 13.3335 9.81962 13.3335 8.33073C13.3335 6.84184 12.8168 5.58073 11.7835 4.5474C10.7502 3.51406 9.48905 2.9974 8.00016 2.9974C6.51127 2.9974 5.25016 3.51406 4.21683 4.5474C3.1835 5.58073 2.66683 6.84184 2.66683 8.33073C2.66683 9.81962 3.1835 11.0807 4.21683 12.1141C5.25016 13.1474 6.51127 13.6641 8.00016 13.6641Z"
            />
          </g>
        </svg>
          </span>
          <div style="
              flex-grow: 1;
            ">
            <strong style="color:#084CBD;">${title}</strong>
            <p style="
              margin: 0;
              margin-top: 4px;
              color: #667085;
              font-weight: 20px;
            ">${description}</p>
          </div>
          <span onclick="document.getElementById('${notificationId}').classList.add('remove-notification'); setTimeout(() => { document.getElementById('${notificationId}').style.display = 'none'; }, 1000);">
        
          <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" style="
              width: 20px;
              height: 20px;
              stroke: #667085;
              stroke-width: 2px;
              transition: opacity 0.2s;
              cursor: pointer;">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </span>
        </div>
      `,
            html: true,
            color: 'white',
            position: 'top-right',
            timeout: 5000,
            badgeStyle: 'display: none;',
        });
    }
    static async success(title, description) {
        const notificationId = `notify-${Date.now()}`;
        Notify.create({
            message: `
 
        <div id="${notificationId}" 
        class="notification-container"
        style="
            display: flex;
            justify-content: space-between;
            padding: 12px;
            max-width: 360px;
            background-color: #ffffff;
            border: 1px solid #e0e0e0;
            margin-top: 32px;
            margin-right: 32px;
            border-radius: 4px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            box-sizing: border-box;
            transition: opacity 1s ease, max-height 1s ease, padding 1s ease, margin 1s ease;
            border-left: 4px solid #99CA3C;
          ">
            
          <span style="align-items:start; justify-content:start;">

        <svg 
          width="20"
          height="20" 
          viewBox="0 0 20 20" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          style="width: 20px; height: 20px; fill:#99CA3C; margin-right: 8px;"
            >
          <mask id="mask0_6424_158876" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
          <rect width="20" height="20" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_6424_158876)">
          <path d="M8.83342 11.5L7.04175 9.70834C6.88897 9.55556 6.69453 9.47917 6.45841 9.47917C6.2223 9.47917 6.02786 9.55556 5.87508 9.70834C5.7223 9.86112 5.64591 10.0556 5.64591 10.2917C5.64591 10.5278 5.7223 10.7222 5.87508 10.875L8.25008 13.25C8.41675 13.4167 8.61119 13.5 8.83342 13.5C9.05564 13.5 9.25008 13.4167 9.41675 13.25L14.1251 8.54167C14.2779 8.38889 14.3542 8.19445 14.3542 7.95834C14.3542 7.72223 14.2779 7.52778 14.1251 7.375C13.9723 7.22223 13.7779 7.14584 13.5417 7.14584C13.3056 7.14584 13.1112 7.22223 12.9584 7.375L8.83342 11.5ZM10.0001 18.3333C8.8473 18.3333 7.76397 18.1146 6.75008 17.6771C5.73619 17.2396 4.85425 16.6458 4.10425 15.8958C3.35425 15.1458 2.7605 14.2639 2.323 13.25C1.8855 12.2361 1.66675 11.1528 1.66675 10C1.66675 8.84723 1.8855 7.76389 2.323 6.75C2.7605 5.73612 3.35425 4.85417 4.10425 4.10417C4.85425 3.35417 5.73619 2.76042 6.75008 2.32292C7.76397 1.88542 8.8473 1.66667 10.0001 1.66667C11.1529 1.66667 12.2362 1.88542 13.2501 2.32292C14.264 2.76042 15.1459 3.35417 15.8959 4.10417C16.6459 4.85417 17.2397 5.73612 17.6772 6.75C18.1147 7.76389 18.3334 8.84723 18.3334 10C18.3334 11.1528 18.1147 12.2361 17.6772 13.25C17.2397 14.2639 16.6459 15.1458 15.8959 15.8958C15.1459 16.6458 14.264 17.2396 13.2501 17.6771C12.2362 18.1146 11.1529 18.3333 10.0001 18.3333ZM10.0001 16.6667C11.8612 16.6667 13.4376 16.0208 14.7292 14.7292C16.0209 13.4375 16.6667 11.8611 16.6667 10C16.6667 8.13889 16.0209 6.56251 14.7292 5.27084C13.4376 3.97917 11.8612 3.33334 10.0001 3.33334C8.13897 3.33334 6.56258 3.97917 5.27091 5.27084C3.97925 6.56251 3.33341 8.13889 3.33341 10C3.33341 11.8611 3.97925 13.4375 5.27091 14.7292C6.56258 16.0208 8.13897 16.6667 10.0001 16.6667Z" fill="#99CA3C"/>
          </g>
        </svg>
        </span>
        <div style="flex-grow: 1;">
            <strong style="color:#99CA3C;">${title}</strong>
            <p style="
              margin: 0;
              margin-top: 4px;
              color: #667085;
              font-weight: 20px;
            ">${description}</p>
          </div>
          <span onclick="document.getElementById('${notificationId}').classList.add('remove-notification'); setTimeout(() => { document.getElementById('${notificationId}').style.display = 'none'; }, 1000);">
        
          <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" style="
              width: 20px;
              height: 20px;
              stroke: #667085;
              stroke-width: 2px;
              transition: opacity 0.2s;
              cursor: pointer;">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </span>
        </div>
      `,
            html: true,
            color: 'white',
            position: 'top-right',
            timeout: 5000,
            badgeStyle: 'display: none;',
            actions: [],
        });
    }
    static async warning(title, description) {
        const notificationId = `notify-${Date.now()}`;
        Notify.create({
            message: `
   
          <div id="${notificationId}" 
          class="notification-container"
          style="
              display: flex;
              justify-content: space-between;
              padding: 12px;
              max-width: 360px;
              background-color: #ffffff;
              border: 1px solid #e0e0e0;
              margin-top: 32px;
              margin-right: 32px;
              border-radius: 4px;
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
              box-sizing: border-box;
              transition: opacity 1s ease, max-height 1s ease, padding 1s ease, margin 1s ease;
              border-left: 4px solid #F2994A;
            ">
              
            <span style="align-items:start; justify-content:start;">
              <svg width="20" height="20" viewBox="0 0 20 20" 
                fill:"none"; xmlns="http://www.w3.org/2000/svg"  
                style="width: 20px; height: 20px; fill:#F2994A; margin-right: 8px;"
                >
                  <mask id="mask0_6424_158885" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                  <rect width="20" height="20" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_6424_158885)">
                  <path d="M10.0001 14.1667C10.2362 14.1667 10.4341 14.0868 10.5938 13.9271C10.7536 13.7674 10.8334 13.5694 10.8334 13.3333C10.8334 13.0972 10.7536 12.8993 10.5938 12.7396C10.4341 12.5799 10.2362 12.5 10.0001 12.5C9.76397 12.5 9.56605 12.5799 9.40633 12.7396C9.24661 12.8993 9.16675 13.0972 9.16675 13.3333C9.16675 13.5694 9.24661 13.7674 9.40633 13.9271C9.56605 14.0868 9.76397 14.1667 10.0001 14.1667ZM10.0001 10.8333C10.2362 10.8333 10.4341 10.7535 10.5938 10.5937C10.7536 10.434 10.8334 10.2361 10.8334 10V6.66666C10.8334 6.43055 10.7536 6.23264 10.5938 6.07291C10.4341 5.91319 10.2362 5.83333 10.0001 5.83333C9.76397 5.83333 9.56605 5.91319 9.40633 6.07291C9.24661 6.23264 9.16675 6.43055 9.16675 6.66666V10C9.16675 10.2361 9.24661 10.434 9.40633 10.5937C9.56605 10.7535 9.76397 10.8333 10.0001 10.8333ZM10.0001 18.3333C8.8473 18.3333 7.76397 18.1146 6.75008 17.6771C5.73619 17.2396 4.85425 16.6458 4.10425 15.8958C3.35425 15.1458 2.7605 14.2639 2.323 13.25C1.8855 12.2361 1.66675 11.1528 1.66675 10C1.66675 8.84722 1.8855 7.76389 2.323 6.75C2.7605 5.73611 3.35425 4.85416 4.10425 4.10416C4.85425 3.35416 5.73619 2.76041 6.75008 2.32291C7.76397 1.88541 8.8473 1.66666 10.0001 1.66666C11.1529 1.66666 12.2362 1.88541 13.2501 2.32291C14.264 2.76041 15.1459 3.35416 15.8959 4.10416C16.6459 4.85416 17.2397 5.73611 17.6772 6.75C18.1147 7.76389 18.3334 8.84722 18.3334 10C18.3334 11.1528 18.1147 12.2361 17.6772 13.25C17.2397 14.2639 16.6459 15.1458 15.8959 15.8958C15.1459 16.6458 14.264 17.2396 13.2501 17.6771C12.2362 18.1146 11.1529 18.3333 10.0001 18.3333ZM10.0001 16.6667C11.8612 16.6667 13.4376 16.0208 14.7292 14.7292C16.0209 13.4375 16.6667 11.8611 16.6667 10C16.6667 8.13889 16.0209 6.5625 14.7292 5.27083C13.4376 3.97916 11.8612 3.33333 10.0001 3.33333C8.13897 3.33333 6.56258 3.97916 5.27091 5.27083C3.97925 6.5625 3.33341 8.13889 3.33341 10C3.33341 11.8611 3.97925 13.4375 5.27091 14.7292C6.56258 16.0208 8.13897 16.6667 10.0001 16.6667Z" fill:#F2994A;/>
                  </g>
              </svg>       
            </span>
            <div style="
                flex-grow: 1;
              ">
              <strong style="color:#F2994A;">${title}</strong>
              <p style="
                margin: 0;
                margin-top: 4px;
                color: #667085;
                font-weight: 20px;
              ">${description}</p>
            </div>
            <span onclick="document.getElementById('${notificationId}').classList.add('remove-notification'); setTimeout(() => { document.getElementById('${notificationId}').style.display = 'none'; }, 1000);">
          
            <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" style="
                width: 20px;
                height: 20px;
                stroke: #667085;
                stroke-width: 2px;
                transition: opacity 0.2s;
                cursor: pointer;">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </span>
          </div>
        `,
            html: true,
            color: 'white',
            position: 'top-right',
            timeout: 5000,
            badgeStyle: 'display: none;',
        });
    }
    static async error(title, description) {
        const notificationId = `notify-${Date.now()}`;
        Notify.create({
            message: `
   
          <div id="${notificationId}" 
          class="notification-container"
          style="
              display: flex;
              justify-content: space-between;
              padding: 12px;
              max-width: 360px;
              background-color: #ffffff;
              border: 1px solid #e0e0e0;
              margin-top: 32px;
              margin-right: 32px;
              border-radius: 4px;
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
              box-sizing: border-box;
              transition: opacity 1s ease, max-height 1s ease, padding 1s ease, margin 1s ease;
              border-left: 4px solid #F3705A;
            ">
              
            <span style="align-items:start; justify-content:start;">
              <svg 
                width="20" 
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="width: 20px; height: 20px; fill:#F3705A; margin-right: 8px;"
                >
                <mask id="mask0_6424_158894" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                <rect width="20" height="20" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_6424_158894)">
                <path d="M10.0001 11.1667L12.4167 13.5833C12.5695 13.7361 12.764 13.8125 13.0001 13.8125C13.2362 13.8125 13.4306 13.7361 13.5834 13.5833C13.7362 13.4306 13.8126 13.2361 13.8126 13C13.8126 12.7639 13.7362 12.5694 13.5834 12.4167L11.1667 10L13.5834 7.58333C13.7362 7.43056 13.8126 7.23611 13.8126 7C13.8126 6.76389 13.7362 6.56944 13.5834 6.41667C13.4306 6.26389 13.2362 6.1875 13.0001 6.1875C12.764 6.1875 12.5695 6.26389 12.4167 6.41667L10.0001 8.83333L7.58341 6.41667C7.43064 6.26389 7.23619 6.1875 7.00008 6.1875C6.76397 6.1875 6.56953 6.26389 6.41675 6.41667C6.26397 6.56944 6.18758 6.76389 6.18758 7C6.18758 7.23611 6.26397 7.43056 6.41675 7.58333L8.83342 10L6.41675 12.4167C6.26397 12.5694 6.18758 12.7639 6.18758 13C6.18758 13.2361 6.26397 13.4306 6.41675 13.5833C6.56953 13.7361 6.76397 13.8125 7.00008 13.8125C7.23619 13.8125 7.43064 13.7361 7.58341 13.5833L10.0001 11.1667ZM10.0001 18.3333C8.8473 18.3333 7.76397 18.1146 6.75008 17.6771C5.73619 17.2396 4.85425 16.6458 4.10425 15.8958C3.35425 15.1458 2.7605 14.2639 2.323 13.25C1.8855 12.2361 1.66675 11.1528 1.66675 10C1.66675 8.84722 1.8855 7.76389 2.323 6.75C2.7605 5.73611 3.35425 4.85417 4.10425 4.10417C4.85425 3.35417 5.73619 2.76042 6.75008 2.32292C7.76397 1.88542 8.8473 1.66667 10.0001 1.66667C11.1529 1.66667 12.2362 1.88542 13.2501 2.32292C14.264 2.76042 15.1459 3.35417 15.8959 4.10417C16.6459 4.85417 17.2397 5.73611 17.6772 6.75C18.1147 7.76389 18.3334 8.84722 18.3334 10C18.3334 11.1528 18.1147 12.2361 17.6772 13.25C17.2397 14.2639 16.6459 15.1458 15.8959 15.8958C15.1459 16.6458 14.264 17.2396 13.2501 17.6771C12.2362 18.1146 11.1529 18.3333 10.0001 18.3333ZM10.0001 16.6667C11.8612 16.6667 13.4376 16.0208 14.7292 14.7292C16.0209 13.4375 16.6667 11.8611 16.6667 10C16.6667 8.13889 16.0209 6.5625 14.7292 5.27083C13.4376 3.97917 11.8612 3.33333 10.0001 3.33333C8.13897 3.33333 6.56258 3.97917 5.27091 5.27083C3.97925 6.5625 3.33341 8.13889 3.33341 10C3.33341 11.8611 3.97925 13.4375 5.27091 14.7292C6.56258 16.0208 8.13897 16.6667 10.0001 16.6667Z" fill="#F3705A"/>
                </g>
              </svg>
            </span>
            <div style="
                flex-grow: 1;
              ">
              <strong style="color:#F3705A;">${title}</strong>
              <p style="
                margin: 0;
                margin-top: 4px;
                color: #667085;
                font-weight: 20px;
              ">${description}</p>
            </div>
            <span onclick="document.getElementById('${notificationId}').classList.add('remove-notification'); setTimeout(() => { document.getElementById('${notificationId}').style.display = 'none'; }, 1000);">
            
            <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" style="
                width: 20px;
                height: 20px;
                stroke: #667085;
                stroke-width: 2px;
                transition: opacity 0.2s;
                cursor: pointer;">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </span>
          </div>
        `,
            html: true,
            color: 'white',
            position: 'top-right',
            timeout: 5000,
            badgeStyle: 'display: none;',
        });
    }
}
